import React, { Component } from "react";
import { Tabs } from "@adrianoferreira/wp-react-admin";
import {FieldGroupContext} from "../../../../../contexts/FieldGroupContext";
import Basic from './Basic';
import RequestParameters from './RequestParameters';
import RequestBody from './RequestBody';
import { connect } from "react-redux";
import { addRestApiCall, removeRestApiCall } from '../../../../../store/actions/restApiCall';
import Headers from './Headers';
import Output from './Output';

const RESTAPICall = ({endpoint, id, addRestApiCallEntry, action, restApiCall, removeRestApiCallEntry}) => {

	return(
		<div id="poststuff" className="display-data-box">
			<div id="slugdiv" className="postbox">
				<h2 className="hndle ui-sortable-handle"><span>Perform Custom External Requests</span></h2>
				<div className="inside" style={{display: 'block'}}>

					<p>Use this action if you want to perform a REST call through your own endpoint. This can be very handy when you need to notify a third party service when certain action is done.</p>

					{restApiCall.map(
						(el, index) =>

							<FieldGroupContext.Provider key={index} value={{
								action: 'restApiCall',
								currentItem: index,
								endpointId: id,
								endpoint: endpoint
							}}>

								<Tabs tabs={[
									{
										name:    'basic',
										title:   'Basic information',
										content: <Basic group={'basic'} key={index + '-defaultFields'}/>
									},
									{
										name: 'requestParameters',
										title: 'Request parameters',
										content: <RequestParameters key={index + '-requestParameters'} group={'requestParameters'}/>
									},
                  {
                    name: 'requestBody',
                    title: 'Request body',
                    content: <RequestBody key={index + '-requestBody'} group={'requestBody'}/>
                  },
									{
										name: 'headers',
										title: 'Request headers',
										content: <Headers key={index + '-headers'} group={'headers'}/>
									},
									{
										name: 'output',
										title: 'Request output',
										content: <Output key={index + '-output'} group={'output'}/>
									},
								]} />

							</FieldGroupContext.Provider>
					)}

				</div>
			</div>
		</div>
	)
};


const mapStateToProps = ( state, props ) => ({
	endpoint: state.settings.endpoints[props.id],
	restApiCall: state.settings.endpoints[props.id].restApiCall,
	id: props.id,
	action: props.endpoint.action,
	opacity: state.settings.endpoints[props.id].opacity,
});

const mapDispatchToProps = dispatch => ({
	addRestApiCallEntry: ( endpointId ) => dispatch( addRestApiCall( endpointId ) ),
	removeRestApiCallEntry: ( endpointId, restCallId ) => dispatch( removeRestApiCall( endpointId, restCallId ) )
});

export default connect(mapStateToProps, mapDispatchToProps)(RESTAPICall);
